import React, { FunctionComponent } from 'react';
import { ArrowBigLeft } from 'lucide-react';
import { Card } from '@companion-professional/components';
import { useNavigate } from 'react-router-dom';
import { NeedHelpContactSupport } from '../NeedHelpContactSupport';
import { PrimaryActionButton } from '../PrimaryActionButton';

interface HelpLayoutProps {
  children: React.ReactNode;
}

// HelpLayout is a layout component that is used for help pages (iOSHelp, AndroidHelp, etc.).  The passed children are
// displayed in a card in the main content area of the layout.
export const HelpLayout: FunctionComponent<HelpLayoutProps> = ({ children }) => {
  const navigate = useNavigate();

  return (
    <div className="flex h-full w-full max-w-lg flex-1 flex-col justify-between gap-4 pb-4">
      <div className="mx-4 mt-4 flex-1">
        <Card className="justify-start p-5 leading-body">{children}</Card>
      </div>
      <div className="space-y-2 px-4">
        <PrimaryActionButton
          onClick={() => {
            navigate(-1);
          }}
        >
          <ArrowBigLeft className="w-5" />
          Back to Checkup
        </PrimaryActionButton>
        <NeedHelpContactSupport />
      </div>
    </div>
  );
};
